import { Component, OnInit, ViewChild } from '@angular/core'
import { CpmService } from '../../../service/cpm.service'
import { StoreService } from '../../../service/store.service'
import { Subscription } from 'rxjs/Subscription'
import { ActivatedRoute } from '@angular/router'
import { RevenueContributionDataComponent } from '../revenue-contribution-data/revenue-contribution-data.component'
import { ExportExcelService } from '../../../service/export-excel.service'

@Component({
  selector: 'app-revenue-contribution-screen',
  templateUrl: './revenue-contribution-screen.component.html',
  styleUrls: ['./revenue-contribution-screen.component.scss']
})
export class RevenueContributionScreenComponent implements OnInit {
  @ViewChild(RevenueContributionDataComponent)
  revenueContributionData: RevenueContributionDataComponent
  subscription: Subscription
  displayComponent = false
  symbol
  excelFile
  constructor(
    private excelService: ExportExcelService,
    private store: StoreService,
    private activatedRoute: ActivatedRoute
  ) {}

  ngOnInit() {
    const { symbol } = this.activatedRoute.snapshot.params
    this.store.getSecurityProfileNewResultObservable().subscribe(response => {
      if (!response) {
        return
      }
      this.symbol = response['securitySymbol']
      if (this.symbol !== '') {
        this.displayComponent = true
      } else {
        this.displayComponent = false
      }
    })
  }
  exportFunctions() {
    const arrayOfFunctions: Map<String, Function> = new Map<String, Function>()
    arrayOfFunctions.set(
      'excel',
      this.exportExcel(
        this.excelService,
        this.revenueContributionData.excelRevenue
      )
    )
    return arrayOfFunctions
  }
  exportExcel(service, excelData) {
    return function excelCorporate() {
      service.exportExcelRevenueContribution(excelData, 'Revenue Contribution')
    }
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/revenue-contribution/revenue-contribution-screen/revenue-contribution-screen.component.ts